<template>
  <div class="showcase-container">
    <!-- 第一页：Hero页面 -->
    <section class="showcase-page hero-page" :class="{ 'active': currentPage === 0 }">
      <!-- 动态背景动画 -->
      <div class="hero-background">
        <div class="floating-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
          <div class="shape shape-5"></div>
          <div class="shape shape-6"></div>
        </div>
        <div class="gradient-overlay"></div>
      </div>
      
      <div class="page-content">
        <div class="hero-content">
          <h1 class="hero-title">
            <span class="title-line">AI图像编辑</span>
            <span class="title-line highlight">重新定义创意</span>
          </h1>
          <p class="hero-subtitle">基于先进的人工智能技术，让您的创意想法变为现实</p>
          <div class="hero-buttons">
            <button class="hero-button primary" @click="scrollToEditor">
              <span>开始探索</span>
              <span class="arrow">→</span>
            </button>
            <button class="hero-button secondary" @click="nextPage">
              <span>了解更多</span>
              <span class="arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- 第二页：功能展示 -->
    <section class="showcase-page feature-page" :class="{ 'active': currentPage === 1 }">
      <div class="page-content">
        <div class="feature-header">
          <h2 class="feature-title">创意无限智能编辑</h2>
          <p class="feature-description">基于上下文感知的AI图像编辑技术，深度理解内容并实现精准编辑</p>
        </div>
        <div class="feature-visual">
          <div class="feature-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#007AFF"/>
                <path d="M19 15L19.74 17.74L22.5 18.5L19.74 19.26L19 22L18.26 19.26L15.5 18.5L18.26 17.74L19 15Z" fill="#007AFF"/>
                <path d="M5 6L5.5 7.5L7 8L5.5 8.5L5 10L4.5 8.5L3 8L4.5 7.5L5 6Z" fill="#007AFF"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>上下文感知</h3>
              <p>深度理解图像内容和编辑意图，确保编辑结果自然协调</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="#007AFF"/>
                <path d="M2 17L12 22L22 17" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>精准控制</h3>
              <p>支持文本引导和局部编辑，精确控制每个细节的修改</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#007AFF" stroke-width="2"/>
              </svg>
            </div>
            <div class="card-content">
              <h3>角色一致性</h3>
              <p>保持人物特征和风格的一致性，确保编辑结果的专业品质</p>
            </div>
          </div>
        </div>
        <div class="page-navigation">
          <button class="nav-button prev" @click="prevPage">← 上一页</button>
          <button class="nav-button next" @click="nextPage">下一页 →</button>
        </div>
      </div>
    </section>

    <!-- 第三页：技术优势 -->
    <section class="showcase-page tech-page" :class="{ 'active': currentPage === 2 }">
      <div class="page-content">
        <div class="tech-header">
          <h2 class="tech-title">技术优势</h2>
          <p class="tech-description">基于先进的上下文感知技术，提供专业级的图像编辑体验</p>
        </div>
        <div class="tech-visual">
          <div class="tech-stats">
            <div class="stat-item">
              <div class="stat-number">精准</div>
              <div class="stat-label">上下文理解</div>
              <div class="stat-description">深度理解图像语义，准确把握编辑意图</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">智能</div>
              <div class="stat-label">内容感知</div>
              <div class="stat-description">自动识别对象关系，保持场景逻辑一致</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">专业</div>
              <div class="stat-label">编辑品质</div>
              <div class="stat-description">输出高质量结果，满足专业创作需求</div>
            </div>
          </div>
          

        </div>
        <div class="page-navigation">
          <button class="nav-button prev" @click="prevPage">← 上一页</button>
          <button class="nav-button next" @click="nextPage">下一页 →</button>
        </div>
      </div>
    </section>

    <!-- 第四页：开始使用 -->
    <section class="showcase-page cta-page" :class="{ 'active': currentPage === 3 }">
      <div class="page-content">
        <div class="cta-header">
          <h2 class="cta-title">开始您的创意之旅</h2>
          <p class="cta-description">上传图片并描述编辑需求，让创意无限为您实现精准的图像编辑</p>
        </div>
        <div class="cta-visual">
          <div class="cta-card">
            <div class="step-container">
              <div class="step-item">
                <div class="step-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="step-content">
                  <h3>上传图片并描述编辑需求</h3>
                  <p>选择图片并详细描述您希望如何修改，创意无限将深度理解您的编辑意图</p>
                </div>
              </div>
              <div class="step-connector"></div>
              <div class="step-item">
                <div class="step-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </div>
                <div class="step-content">
                  <h3>获得专业编辑结果</h3>
                  <p>创意无限为您生成自然协调、保持角色一致性的专业编辑效果</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="page-navigation">
          <button class="nav-button return-start" @click="goToPage(0)">返回开始</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const currentPage = ref(0);
const totalPages = 4;

const nextPage = () => {
  if (currentPage.value < totalPages - 1) {
    currentPage.value++;
  }
};

const prevPage = () => {
  if (currentPage.value > 0) {
    currentPage.value--;
  }
};

const goToPage = (page) => {
  currentPage.value = page;
};

const scrollToEditor = () => {
  // 滚动到图像编辑组件
  const editorElement = document.querySelector('#ai-image-editor');
  if (editorElement) {
    editorElement.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }
};





// 键盘导航
const handleKeydown = (event) => {
  if (event.key === 'ArrowRight') {
    nextPage();
  } else if (event.key === 'ArrowLeft') {
    prevPage();
  }
};

// 触摸滑动支持
let startX = 0;
let startY = 0;

const handleTouchStart = (event) => {
  startX = event.touches[0].clientX;
  startY = event.touches[0].clientY;
};

const handleTouchEnd = (event) => {
  const endX = event.changedTouches[0].clientX;
  const endY = event.changedTouches[0].clientY;
  const diffX = startX - endX;
  const diffY = startY - endY;

  // 确保是水平滑动
  if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
    if (diffX > 0) {
      nextPage();
    } else {
      prevPage();
    }
  }
};

onMounted(() => {
  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('touchstart', handleTouchStart);
  document.addEventListener('touchend', handleTouchEnd);
});

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeydown);
  document.removeEventListener('touchstart', handleTouchStart);
  document.removeEventListener('touchend', handleTouchEnd);
});
</script>

<style scoped>
.showcase-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: auto;
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.showcase-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: auto;
  opacity: 0;
  transform: translateX(100%);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.showcase-page.active {
  opacity: 1;
  transform: translateX(0);
  display: flex;
}

.showcase-page:not(.active) {
  transform: translateX(-100%);
  display: none;
}

/* 统一白色主题样式 */
.hero-page,
.feature-page,
.tech-page,
.cta-page {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  color: #1a1a1a;
}

/* Hero页面样式 */
.hero-page {
  position: relative;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(0, 122, 255, 0.1) 0%, rgba(0, 198, 255, 0.1) 100%);
  animation: float 20s infinite linear;
}

.shape-1 {
  width: 120px;
  height: 120px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
  animation-duration: 25s;
}

.shape-2 {
  width: 80px;
  height: 80px;
  top: 20%;
  right: 15%;
  animation-delay: -5s;
  animation-duration: 30s;
}

.shape-3 {
  width: 100px;
  height: 100px;
  bottom: 20%;
  left: 20%;
  animation-delay: -10s;
  animation-duration: 28s;
}

.shape-4 {
  width: 60px;
  height: 60px;
  bottom: 30%;
  right: 10%;
  animation-delay: -15s;
  animation-duration: 22s;
}

.shape-5 {
  width: 90px;
  height: 90px;
  top: 50%;
  left: 5%;
  animation-delay: -8s;
  animation-duration: 35s;
}

.shape-6 {
  width: 70px;
  height: 70px;
  top: 60%;
  right: 5%;
  animation-delay: -12s;
  animation-duration: 26s;
}

@keyframes float {
  0% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.3;
  }
  25% {
    opacity: 0.6;
  }
  50% {
    transform: translateY(-30px) rotate(180deg);
    opacity: 0.4;
  }
  75% {
    opacity: 0.7;
  }
  100% {
    transform: translateY(0px) rotate(360deg);
    opacity: 0.3;
  }
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 30% 20%, rgba(0, 122, 255, 0.05) 0%, transparent 50%),
              radial-gradient(circle at 70% 80%, rgba(0, 198, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.page-content {
  text-align: center;
  max-width: 1400px;
  width: 100%;
  z-index: 2;
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  box-sizing: border-box;
  flex: 1;
}

.hero-content {
  text-align: center;
  max-width: 900px;
  z-index: 2;
  position: relative;
  margin: 0 auto;
}

.hero-title {
  font-size: 4rem;
  font-weight: 700;
  margin-bottom: 24px;
  line-height: 1.1;
  color: #1a1a1a;
}

.title-line {
  display: block;
}

.title-line.highlight {
  background: linear-gradient(135deg, #007AFF 0%, #0056CC 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: #666666;
  margin-bottom: 40px;
  font-weight: 400;
}

.hero-button {
  background: linear-gradient(135deg, #007AFF 0%, #00C6FF 100%);
  color: #ffffff;
  border: none;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 1.15rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 12px 32px rgba(0, 122, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.hero-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.hero-button:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 20px 40px rgba(0, 122, 255, 0.4);
}

.hero-button:hover::before {
  left: 100%;
}

.hero-button .arrow {
  transition: transform 0.3s ease;
}

.hero-button:hover .arrow {
  transform: translateX(4px);
}

.hero-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.hero-button.primary {
  background: linear-gradient(135deg, #007AFF 0%, #00C6FF 100%);
  box-shadow: 0 12px 32px rgba(0, 122, 255, 0.3);
}

.hero-button.primary:hover {
  box-shadow: 0 20px 40px rgba(0, 122, 255, 0.4);
}

.hero-button.secondary {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border: 2px solid #6c757d;
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(108, 117, 125, 0.3);
}

.hero-button.secondary:hover {
  background: linear-gradient(135deg, #5a6268 0%, #343a40 100%);
  border-color: #5a6268;
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 12px 32px rgba(108, 117, 125, 0.4);
}



/* 功能页面样式 */
.feature-header {
  text-align: center;
  margin-bottom: 60px;
  flex-shrink: 0;
}



.feature-visual {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 50px;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  flex: 1;
  align-items: center;
}

.feature-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.feature-description {
  font-size: 1.25rem;
  color: #666666;
  max-width: 600px;
  margin: 0 auto;
}

.feature-visual {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 50px;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
}

.feature-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  border-radius: 24px;
  padding: 50px 40px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #007AFF 0%, #00C6FF 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 24px 48px rgba(0, 122, 255, 0.15);
  border-color: #e3f2fd;
}

.feature-card:hover::before {
  transform: scaleX(1);
}

.card-icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.1);
  transition: all 0.3s ease;
}

.feature-card:hover .card-icon {
  transform: scale(1.1);
  box-shadow: 0 8px 24px rgba(0, 122, 255, 0.2);
}

.card-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #1a1a1a;
}

.card-content p {
  color: #666666;
  line-height: 1.6;
}

/* 技术页面样式 */
.tech-header {
  text-align: center;
  margin-bottom: 60px;
  flex-shrink: 0;
}



.tech-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  flex: 1;
}

.tech-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.tech-description {
  font-size: 1.25rem;
  color: #666666;
  max-width: 600px;
  margin: 0 auto;
}

.tech-visual {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.tech-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 50px;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
}

.stat-item {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  border-radius: 24px;
  padding: 50px 40px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
}

.stat-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #007AFF 0%, #00C6FF 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 24px 48px rgba(0, 122, 255, 0.15);
  border-color: #e3f2fd;
}

.stat-item:hover::before {
  transform: scaleX(1);
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 800;
  background: linear-gradient(135deg, #007AFF 0%, #00C6FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 16px;
  display: block;
  transition: all 0.3s ease;
}

.stat-item:hover .stat-number {
  transform: scale(1.1);
}

.stat-label {
  font-size: 1.3rem;
  color: #666666;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.stat-description {
  font-size: 0.95rem;
  color: #888888;
  line-height: 1.6;
}



/* CTA页面样式 */
.cta-header {
  text-align: center;
  margin-bottom: 40px;
  flex-shrink: 0;
}



.cta-visual {
  margin-bottom: 40px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cta-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.cta-description {
  font-size: 1.25rem;
  color: #666666;
  max-width: 600px;
  margin: 0 auto;
}

.cta-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid #e9ecef;
  border-radius: 20px;
  padding: 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.cta-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #007AFF 0%, #00C6FF 100%);
}

.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.step-item {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  width: 100%;
  max-width: 500px;
  position: relative;
}

.step-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 122, 255, 0.12);
  border-color: #e3f2fd;
}

.step-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #007AFF 0%, #00C6FF 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 25px;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(0, 122, 255, 0.25);
  color: #ffffff;
  position: relative;
}

.step-icon::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #007AFF 0%, #00C6FF 100%);
  border-radius: 22px;
  z-index: -1;
  opacity: 0.3;
}

.step-connector {
  width: 3px;
  height: 30px;
  background: linear-gradient(180deg, #007AFF 0%, #00C6FF 100%);
  border-radius: 2px;
  margin: 0 auto;
  position: relative;
}

.step-connector::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  background: #007AFF;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
}

.step-content {
  flex: 1;
}

.step-content h3 {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #1a1a1a;
  background: linear-gradient(135deg, #1a1a1a 0%, #333333 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.step-content p {
  color: #666666;
  line-height: 1.6;
  font-size: 0.95rem;
  margin: 0;
}



/* 页面导航 */
.page-navigation {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 40px;
}

.nav-button {
  background: #f8f9fa;
  color: #666666;
  border: 1px solid #e9ecef;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-button:hover {
  background: #e9ecef;
  color: #1a1a1a;
}

.nav-button.return-start {
  background: linear-gradient(135deg, #007AFF 0%, #00C6FF 100%);
  color: #ffffff;
  border: none;
  box-shadow: 0 8px 24px rgba(0, 122, 255, 0.3);
  font-weight: 600;
  transition: all 0.3s ease;
}

.nav-button.return-start:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(0, 122, 255, 0.4);
  background: linear-gradient(135deg, #0056CC 0%, #0099CC 100%);
}



/* 响应式设计 */
@media (max-width: 768px) {
  .page-content {
    padding: 40px 0;
    min-height: 100vh;
    height: auto;
    justify-content: flex-start;
  }
  
  .hero-buttons {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  
  .hero-button {
    width: 100%;
    max-width: 280px;
    justify-content: center;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .feature-title,
  .tech-title,
  .cta-title {
    font-size: 2.5rem;
  }
  
  .feature-visual {
    grid-template-columns: 1fr;
    gap: 30px;
    max-width: 100%;
  }
  
  .tech-stats {
    grid-template-columns: 1fr;
    gap: 30px;
    max-width: 100%;
  }
  
  .stat-item {
    padding: 30px 20px;
  }
  
  .stat-number {
    font-size: 2.2rem;
  }
  
  .stat-label {
    font-size: 1.1rem;
  }
  
  .stat-description {
    font-size: 0.9rem;
  }
  
  .feature-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  

  
  .cta-card {
    padding: 25px 15px;
  }
  
  .step-container {
    gap: 25px;
  }
  
  .step-item {
    padding: 18px;
    flex-direction: column;
    text-align: center;
    max-width: 400px;
  }
  
  .step-icon {
    width: 50px;
    height: 50px;
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .step-connector {
    height: 25px;
  }
  
  .step-content h3 {
    font-size: 1.1rem;
  }
  
  .step-content p {
    font-size: 0.9rem;
  }
  
  .page-navigation {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .showcase-page {
    padding: 0 16px;
    min-height: 100vh;
    height: auto;
    position: relative;
    width: 100%;
  }
  
  .page-content {
    padding: 40px 20px;
    min-height: 100vh;
    height: auto;
    justify-content: flex-start;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .feature-title,
  .tech-title,
  .cta-title {
    font-size: 2rem;
  }
  
  .feature-visual {
    grid-template-columns: 1fr;
  }
  
  .feature-card {
    padding: 30px 20px;
  }
  
  .tech-stats {
    gap: 30px;
  }
  
  .stat-item {
    padding: 20px;
  }
}
</style> 